import Banners from './Banners';

export default Banners;


// WEBPACK FOOTER //
// ./src/components/Query/Banners/index.ts